import * as React from 'react';
import styles from './OnlineModal.module.scss';
import ScreenIcon from 'components/assets/svg/exam/screen_icon.svg';
import { UserVideo } from 'components';
import cn from 'classnames';
import { Button } from 'react-bootstrap';
import TestDisplayPoster from 'components/assets/gif/test_display.gif';


const ScreenTest: React.FC<IProps> = (props) => {
    const steps: IStep[] = [
        {
            index: 1,
            text: '1. Нажмите на кнопку «Проверить доступность экрана»',
            buttonText: 'Проверить доступность экрана',
            video: TestDisplayPoster,
        },
        {
            index: 2,
            text: '2. Дайте сайту доступ ко всему экрану вашего компьютера',
            buttonText: 'Проверить доступность экрана',
            disableButton: true,
            video: TestDisplayPoster,
        },
        {
            index: 3,
            text: '3. Если вы видите в окне ваш экран - все работает как надо!',
            buttonText: 'Вижу экран',
            emoji: '👍',
        },
    ];

    const errorText = [
        'Мы заметили, что вы отклонили запрос на предоставление доступа к экрану. ',
        'В соответствии с Правилами проведения экзамена, вы должны предоставить доступ к экрану.',
        'Для исправления ситуации, пожалуйста, следуйте видео-инструкции слева или нажмите на кнопку «Начать проверку заново».',
    ];

    const errorPoster = TestDisplayPoster;

    const [currStep, setStep] = React.useState<IStep | null>(steps[0]);
    const [isError, setError] = React.useState(false);
    const [stream, setStream] = React.useState<MediaStream | null>(null);

    const handleStart = React.useCallback(async () => {
        if (navigator.mediaDevices) {
            try {
                setStep(steps[1]);
                const mediaStream = await (navigator.mediaDevices as any).getDisplayMedia({
                    video: true,
                });

                setStep(steps[2]);
                setStream(mediaStream);
            } catch (e) {
                setError(true);
            }
        }
    }, []);

    const handler = React.useMemo(() => {
        if (isError) {
            return () => {
                setStep(steps[0]);
                setError(false);
            };
        }

        if (!currStep) {
            return props.onNextTest;
        }

        if (currStep.index === 1) {
            return handleStart;
        }

        if (currStep.index === 3) {
            return () => {
                setStep(null);
                props.onSuccess();
            };
        }

        return () => {
        };
    }, [currStep, isError]);

    const buttonText = React.useMemo(() => {
        if (isError) {
            return 'Начать проверку заново';
        }

        if (currStep) {
            return currStep.buttonText;
        }

        return 'Завершить техническую проверку';
    }, [currStep, isError]);

    React.useEffect(() => () => {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    }, [stream]);


    const screenPoster = isError ? errorPoster : currStep ? currStep.video : undefined;
    return (
      <div className={styles.testContainer}>
          <div>
              {(!currStep || currStep.index > 1) && (
                <UserVideo
                  muted
                  containerClassName={styles.videoContainer}
                  className={cn(styles.video, { [styles.autoHeight]: !!(screenPoster) })}
                  videoStream={stream || undefined}
                  poster={screenPoster}
                  withoutFullScreen
                />
              )}
          </div>
          <div className={styles.testStepper}>
              {currStep ? (
                isError ? (
                  <>
                      <h4>Нет доступа к экрану ️<span aria-label="who knows emoji" role="img">🤷🏻‍♂</span>️</h4>
                      {errorText.map((t, i) => (
                        <div key={i} className={styles.errorText}>
                            {t}
                        </div>
                      ))}
                  </>
                ) : (
                  <>
                      <h4>Как проверить доступность экрана?</h4>
                      <ul>
                          {steps.map((step, i) => (
                            <li key={step.index} className={cn({ [styles.active]: i + 1 === currStep.index })}>
                                {step.text} {step.emoji ? <span>{step.emoji}</span> : null}
                            </li>
                          ))}
                      </ul>
                  </>
                )
              ) : (
                <div className={styles.end}>
                    <img src={ScreenIcon} alt="ScreenIcon" />
                    Есть доступ к экрану
                </div>
              )}
              <Button
                className="mt-5"
                disabled={Boolean(currStep && currStep.disableButton && !isError)}
                onClick={handler}
              >
                  {buttonText}
              </Button>
          </div>
      </div>
    );
};

interface IProps {
    onNextTest: () => void;
    onSuccess: () => void;
}

interface IStep {
    index: number;
    text: string;
    buttonText: string;
    disableButton?: boolean;
    video?: string;
    emoji?: string;
}

export default ScreenTest;
